<template>
  <div class="home">
    <app-header></app-header>
    <app-smart-meter></app-smart-meter>
    <app-footer></app-footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/general/Header.vue";
import SmartMeter from "@/components/smartmeter/smartmeter.vue";
import Footer from "@/components/general/Footer.vue";


export default {
name: "home",
components: {
  'app-header': Header,
  'app-smart-meter': SmartMeter,
  'app-footer' : Footer,
  }
}   

</script>
